module.exports = __webpack_public_path__ + "static/media/about.e87a6b73.jpg";